"use client";

import Form, { EmailInput, SecretInput, TextareaInput } from "@/components/forms";
import { NewsletterLeaveForm as schema } from "@/types";

type Props = {}

export const NewsletterLeaveForm: React.FC<Props> = ({ }) => {
    return (
        <Form code="newsletter:leave" schema={schema} title="Leave our Newsletter" description="Once you leave, you will no longer receive the latest insights on Telephony Voice AI Agents, technology, and business growth." buttonName="Leave" initialValues={{ code: "", reason: "" }}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <EmailInput name="email" label="What is your email address?" description="required" placeholder="e.g. john.doe@example.com" />
                <SecretInput name="code" label="What is your leave code?" description="required" placeholder="e.g. 9bddf5bd-5287-42dc-bab3-e61b327b04d9" />
            </div>
            <TextareaInput name="reason" label="Is there a reason you're leaving?" description="optional" placeholder="Please let us know if there's anything we could improve..." />
        </Form>
    );
}